<template>
  <div class="register">
    <div class="card" style="height: 300px;" v-if="!loading">
        <h2>Register Account</h2>
        <input type="email" v-model="email" name="email" placeholder="E-mail">
        <input type="password" v-model="password" name="password" placeholder="Password">
        <input type="password" v-model="repeatedPassword" name="repeat-password" placeholder="Repeat Password" @keydown.enter="register">
        <div class="bottom">
            <button @click="$router.push('/login')" class="empty">Back</button>
            <button @click="register">Register</button>
        </div>
    </div>
    <div class="card loader" v-else>
        <loader></loader>
    </div>
  </div>
</template>

<script>
import config from '../config';
import Loader from './Loader.vue';

export default {
    name: 'Register',
    data () {
        return {
            email: '',
            password: '',
            repeatedPassword: '',
            loading: false
        }
    },
    components: {
        Loader
    },
    methods: {
        register() {
            this.loading = true;
            const email = this.email;
            const password = this.password;

            if (password !== this.repeatedPassword) {
                this.notificationController.addNotification({ type: 'error', title: 'Registration failed', message: 'Passwords do not match.', duration: 3000 });
                this.loading = false;
                return;
            }

            fetch(config.api + '/auth/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    password: password
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(data => {
                this.notificationController.addNotification({ type: 'success', title: 'Registration successful', message: 'Account registered successfully, please validate your email by clicking the link in the email we sent you.', duration: 5000 });

                this.$router.push('/login');
            })
            .catch(error => {
                console.error(error);
                this.notificationController.addNotification({ type: 'error', title: 'Registration failed', message: 'Something went wrong, try again.', duration: 3000 });
            })
            .finally(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>

.register {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
}

h2 {
    text-align: center;
}

.card {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

input {
    width: 90%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border-radius: 8px;
    outline: none;
}

button {
    align-self: center;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border-radius: 8px;

    font-size: 16px;
    cursor: pointer;
}

.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
}

.bottom {
    display: flex;
    justify-content: space-between;
}

</style>


// WEBPACK FOOTER //
// src/components/Register.vue